import React from "react";

import { useViewport } from "utilities/hookutils";
import Calendar from "./calendar/calendar";
import Filters from "./filters/Filters";
import { AddTagsModal, ChangeOwnerModal, ChangePublicationModal, ChangeStatusModal, ReplaceTagsModal } from "components/Tables/MySelection/Modals";
import toggleableLayout from "./toggleableLayout";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import ListTemplate from "components/ListTemplate";
import TrainModal from "train/TrainModal";
import { useLoaderData } from "react-router";

const ShowListInternalApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ShowListInternalFrontModel>();

  const viewport = useViewport();

  const renderExtraFilters = ({ instruction, initialLoading }) => {
    if (viewport === "mobile") {
      return null;
    }

    return <div>
      <Calendar instruction={instruction} isDoingFirstLoad={initialLoading} />
    </div>;
  };

  return <>
    <TrainModal />
    <ListTemplate
      title={site.currentEnvironment.show.plural}
      filterSet="show_List"
      defaultFilters={viewModel.defaultFilters}
      initialInstruction={viewModel.initialInstruction}
      fetchFunction={window.CoreApi.Show.PaginatedInternalEnvironment}
      getId={item => item.showId}
      layout={toggleableLayout(viewport, viewModel)}
      filters={<Filters initialTags={viewModel.tags} initialStatuses={viewModel.statuses} initialBookkeepings={viewModel.bookkeepings} />}
      renderExtraFilters={renderExtraFilters}
      functions={{
        mapFilterValuesToInstruction,
        mapResponseToFilterValues
      }}
      options={{
        filterPreset: {
          cacheKey: "show_List",
          listApi: window.CoreApi.FilterPreset.ListFilterPresetsForShow,
          mutateApi: window.CoreApi.FilterPreset.CreateFilterPresetForShow
        },
        exportOptions: {
          canExportList: site.permissions.show.canExportList,
          exportOptionsApi: window.CoreApi.Show.ExportOptionsForListInternalEnvironment
        },
        mySelection: {
          mainArea: "show",
          isSelected: (item) => item.isSelected,
          batchActions: [{
            label: RESX.Status.ChangeStatus,
            modal: ChangeStatusModal,
            props: { statuses: viewModel.statuses }
          }, {
            label: RESX.Planning.ChangePublishStatus,
            modal: ChangePublicationModal
          }, {
            label: RESX.Tag.ReplaceTags,
            modal: ReplaceTagsModal,
            props: { tags: viewModel.tags }
          }, {
            label: RESX.Tag.AddTags,
            modal: AddTagsModal,
            props: { tags: viewModel.tags }
          }, {
            label: RESX.Planning.ChangeOwner,
            modal: ChangeOwnerModal
          }]
        }
      }}
    />
  </>;
};

export default ShowListInternalApp;